export function cleanName(name: string): string {
  return typeof name === 'string'
    ? name.replace(
        /[^A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s.'-]*/g,
        ''
      )
    : ''
}
